import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { hideWintCardPromotion } from "store/actions/authActions";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ActionLinkButton, Icon, StyledButton, useFloatingMessages } from "components/common";
import { useWintCardService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const WintCardDialogContent: React.FC = () => {
  const wintCardService = useWintCardService();
  const [sendingRequest, setSendingRequest] = React.useState<boolean>();

  const dispath = useDispatch();
  const { enqueueMessage } = useFloatingMessages();

  const isRealEstateAgentCompany = useSelector((store: AppState) => store.auth.selectedCompany.isAgentSalesActive);

  const onAcceptButtonClick = async () => {
    setSendingRequest(true);
    return wintCardService
      .requestWintCardRegistration()
      .then(() => {
        dispath(hideWintCardPromotion());
        enqueueMessage(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.WintCardAcceptSuccessMessage),
          StyleEnums.DisplayType.Success
        );
      }, UtilsHelper.emptyFunc)
      .finally(() => {
        setSendingRequest(false);
        dispath(closeDialog());
      });
  };

  const onRejectButtonClick = async () => {
    wintCardService.rejectWintCardRegistration().then(UtilsHelper.emptyFunc, UtilsHelper.emptyFunc);
    dispath(hideWintCardPromotion());
    dispath(closeDialog());
  };

  const goToLink = () => {
    window.open("https://www.wint.se/kort/info", "_blank");
  };

  return (
    <Grid container rowGap={3}>
      <Grid item className={cssExports.walkingManContent}>
        <Grid item container rowGap={3}>
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(
              isRealEstateAgentCompany
                ? TranslationKeys.Receipt.WintCardPromotionForRealEstateAgentsContent1
                : TranslationKeys.Receipt.WintCardPromotionContent1
            )}
          </Grid>
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(
              isRealEstateAgentCompany
                ? TranslationKeys.Receipt.WintCardPromotionForRealEstateAgentsContent2
                : TranslationKeys.Receipt.WintCardPromotionContent2
            )}
          </Grid>
          <Grid item>
            <ActionLinkButton onClick={goToLink} endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.WintCardPromotionContent3)}
            </ActionLinkButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container columnGap={1} direction="row" wrap="nowrap">
        <Grid item>
          <StyledButton
            size="xs"
            className={cssExports.smallbtn}
            onClick={onRejectButtonClick}
            disabled={sendingRequest}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.WintCardPromotionRejectButtonText)}
          </StyledButton>
        </Grid>
        <Grid item>
          <StyledButton
            size="xs"
            className={cssExports.smallbtn}
            onClick={onAcceptButtonClick}
            isSubmitting={sendingRequest}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.WintCardPromotionAcceptButtonText)}
          </StyledButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WintCardDialogContent;
